// @flow

/**
 * Get an array of group levels that are currently collapsed in the grid.
 * Returns unique levels where at least one group row is collapsed.
 * @param {Object} grid - The Wijmo FlexGrid instance
 * @returns {Array<number>} Array of collapsed group levels
 */
export const getCollapsedGroupLevels = (grid: any): Array<number> => {
  if (!grid || !grid.rows) {
    return [];
  }

  const collapsedLevels = new Set();

  for (let i = 0; i < grid.rows.length; i++) {
    const row = grid.rows[i];
    if (row.hasChildren && row.isCollapsed) {
      collapsedLevels.add(row.level);
    }
  }

  return Array.from(collapsedLevels).sort((a, b) => a - b);
};

/**
 * Apply collapsed state to group rows at specified levels.
 * @param {Object} grid - The Wijmo FlexGrid instance
 * @param {Array<number>} collapsedLevels - Array of levels to collapse
 */
export const applyCollapsedGroupLevels = (grid: any, collapsedLevels: Array<number>): void => {
  if (!grid || !grid.rows || !Array.isArray(collapsedLevels)) {
    return;
  }

  const levelsSet = new Set(collapsedLevels);

  for (let i = 0; i < grid.rows.length; i++) {
    const row = grid.rows[i];
    if (row.hasChildren) {
      row.isCollapsed = levelsSet.has(row.level);
    }
  }
};
